/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
//#endregion
//#region Syles
import { Column, ContainerForm, ContentForm } from "components/styles";
import { Footer, ParagraphContentDeleteEventDialog } from "./styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import CustomButton from "components/CustomButton/CustomButton";
import BackToView from "components/BackToView/BackToView";
import HeaderDetail from "./components/HeaderDetail";
import CustomTabs from "components/CustomTabs/CustomTabs";
import EventDetail from "../components/EventDetail/EventDetail";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import ToastMessage from "components/ToastMessage/ToastMessage";
import EventDurationDetail from "../components/EventDurationDetail/EventDurationDetail";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Services
import {
	requestGetEventDaysByEventId,
} from "services/events/aboutEvents";
//#endregion
//#region Utils
import useResumeData from "views/Eventos/utils/hooks/useResumeData";
import useDataRelatedToForm from "views/Eventos/utils/hooks/useDataRelatedToForm";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { USER_ROLES } from "config/userPermissions";
import {
	DAY_IN_MILLIS,
	MONTHS,
	getDateFormattedWithMillis,
	getDatePartsByMillis,
	getTodayWithoutHourInMillis,
	getWeekStringRangeOf,
	getWeekDateRange,
} from "components/CustomDatePicker/utils/helpers";
//#endregion
//#region Services
import { eventsSessionStorage } from "services/storage/events";
//#endregion
//#region Utils
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import { EVENT_DETAIL_TABS_INFO } from "./utils/constants";
import { EVENTS_CONSTANTS } from "config/constants";
import CheckEventExistence from "../components/CheckEventExistence/CheckEventExistence";
import useDeleteEvent from "./utils/hooks/useDeleteEvent";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const EventDetailView = ({ userRole }) => {
	const loadingRequest = useLoadingRequest();
	const isTeacherUser = (userRole === USER_ROLES.EVENTOS_DOCENTE || userRole === USER_ROLES.REF_ACAD_TUTOR);
	const isCancelled = eventsSessionStorage.isCancelledEvent.get();
	//#region States
	const [loadedDataRelatedToEventForm, setLoadedDataRelatedToEventForm] =
		useState(false);
	const [toastMessage, setToastMessage] = useState({
		hidden: true,
		message: "",
	});
	const [eventDateListGroup, setEventDateListGroup] = useState(null);
	//#endregion
	const navigate = useNavigate();
	const [fetchData, dataRelatedToForm] = useDataRelatedToForm({
		loadingRequest,
		setLoadedDataRelatedToEventForm,
	});
	const eventResumeData = useResumeData({
		loadingRequest,
		dataRelatedToForm,
		loadedDataRelatedToEventForm,
	});
	//#region Effects
	useEffect(() => {
		fetchData();
	}, []);
	useEffect(() => {
		if (!eventResumeData.value || isCancelled || isOnlyDayEvent()) {
			setEventDateListGroup([]);
			return;
		}
		fillGroupingDateList();
	}, [eventResumeData.value]);
	//#endregion
	const deleteEvent = useDeleteEvent({
		loadingRequest,
		eventResumeData: eventResumeData.value,
		goToEventList,
	});
	//#region Functions
	const isOnlyDayEvent = () => {
		if (!eventResumeData.value) return null;
		return (
			eventResumeData.value.step1.duration.period ===
			EVENT_PERIOD_IDS.ONLY_DAY
		);
	};
	const fillGroupingDateList = async () => {
		loadingRequest.show();
		const fetchEventDateList = await requestGetEventDaysByEventId(
			eventsSessionStorage.eventId.get(),
			!isTeacherUser
		);
		loadingRequest.hide();
		const getWeek = ([firstDate, lastDate], eventDateList) => {
			return {
				title: `Semana del ${getWeekStringRangeOf(
					[firstDate, lastDate],
					"al",
					1
				)}`,
				dateList: eventDateList.filter(({ date }) => {
					return date.value >= firstDate && date.value <= lastDate;
				}),
			};
		};
		const [firstDayOfTheFirstWeekOfDateList] = getWeekDateRange(
			new Date(fetchEventDateList[0].date.value)
		);
		const lastDayOfTheLastWeekOfDateList = getWeekDateRange(
			new Date([...fetchEventDateList].pop().date.value)
		)[1];
		let newEventDateListGroup = {
			currentWeek: [],
			future: {
				months: fetchEventDateList.reduce((months, { date }) => {
					const monthName =
						MONTHS[
						getDatePartsByMillis(
							getWeekDateRange(new Date(date.value))[0]
						)[1]
						];
					if (!months.includes(monthName))
						return [...months, monthName];
					return [...months];
				}, []),
				weeks: {},
			},
		};
		newEventDateListGroup.future.weeks = Object.fromEntries(
			newEventDateListGroup.future.months.map(monthName => {
				return [monthName, []];
			})
		);
		// showDateList(fetchEventDateList);
		const hasPastDates = () => {
			return (
				firstDayOfTheFirstWeekOfDateList <
				getWeekDateRange(new Date(getTodayWithoutHourInMillis()))[0]
			);
		};
		for (
			let firstWeekDayMillis = firstDayOfTheFirstWeekOfDateList.getTime(),
			week = 1;
			firstWeekDayMillis < lastDayOfTheLastWeekOfDateList.getTime();
			firstWeekDayMillis += DAY_IN_MILLIS * 7, week++
		) {
			const startDateWeek = new Date(firstWeekDayMillis),
				lastDateWeek = new Date(firstWeekDayMillis + DAY_IN_MILLIS * 6);
			if (week === 1 || (week === 2 && hasPastDates())) {
				newEventDateListGroup.currentWeek.push(
					getWeek([startDateWeek, lastDateWeek], fetchEventDateList)
				);
				continue;
			}
			const monthName = MONTHS[new Date(firstWeekDayMillis).getMonth()];
			if (!newEventDateListGroup.future.months.includes(monthName))
				continue;
			newEventDateListGroup.future.weeks = {
				...newEventDateListGroup.future.weeks,
				[monthName]: [
					...newEventDateListGroup.future.weeks[monthName],
					getWeek(
						[startDateWeek, lastDateWeek],
						fetchEventDateList.filter(({ date }) => {
							const currentMonthName =
								MONTHS[
								getWeekDateRange(
									new Date(date.value)
								)[0].getMonth()
								];
							return monthName === currentMonthName;
						})
					),
				],
			};
		}
		newEventDateListGroup.future = deleteMonthsWithoutWeeks(
			newEventDateListGroup.future
		);
		setEventDateListGroup(newEventDateListGroup);
	};
	const deleteMonthsWithoutWeeks = future => {
		const monthsWithoutWeeks = Object.entries(future.weeks)
			.filter(([_, v]) => v.length === 0)
			.map(([key]) => key);
		return {
			months: future.months.filter(
				month => !monthsWithoutWeeks.includes(month)
			),
			weeks: Object.fromEntries(
				Object.entries(future.weeks).filter(
					([k, v]) => !monthsWithoutWeeks.includes(k)
				)
			),
		};
	};
	const toStep = step => {
		eventsSessionStorage.currentEventFormStep.set(step);
		navigate(ABSOLUTE_PATHS.UPDATE_EVENT_MANUAL_LOADING);
	};
	const getIsDraft = () => eventsSessionStorage.isDraftEvent.get();
	const fillEventDataToAttendance = data => {
		eventsSessionStorage.eventDataForAttendance.set({
			id: eventResumeData.value.step1.id,
			dateEventId: data.dateEventId,
		});
	};
	const getRenderContentToDeleteEvent = () => {
		if (!eventResumeData.value) return null;
		const {
			title,
			duration: { onlyDay, manyDays },
		} = eventResumeData.value.step1;
		let dateFormatted = "";
		if (onlyDay) {
			dateFormatted = getDateFormattedWithMillis(onlyDay.date);
		}
		if (manyDays)
			dateFormatted = `${getDateFormattedWithMillis(
				manyDays.date.start
			)} al ${getDateFormattedWithMillis(manyDays.date.end)}`;
		return (
			<ParagraphContentDeleteEventDialog>
				{dateFormatted} del Evento "{title}"
				<br />
				Este evento completo que programaste se eliminará, sin opción a
				recuperarla
			</ParagraphContentDeleteEventDialog>
		);
	};
	function goToEventList() {
		navigate(ABSOLUTE_PATHS.EVENT_LIST);
	}
	//#endregion
	const [currentTabIdx, setCurrentTabIdx] = useState(0);
	if (getIsDraft())
		return (
			<Navigate
				to={ABSOLUTE_PATHS.UPDATE_EVENT_MANUAL_LOADING}
				replace
			/>
		);
	const canUpdate = !isCancelled && !isTeacherUser;
	const views = [
		<EventDetail
			dataRelatedToForm={dataRelatedToForm}
			eventResumeData={eventResumeData.value}
			toStep={toStep}
			cannotUpdate={!canUpdate}
		/>,
		<EventDurationDetail
			loadingRequest={loadingRequest}
			isTeacherUser={isTeacherUser}
			title={eventResumeData.value?.step1.title}
			eventDateListGroup={eventDateListGroup}
			setToastMessage={setToastMessage}
			fillGroupingDateList={fillGroupingDateList}
			fillEventDataToAttendance={fillEventDataToAttendance}
		/>,
	];
	const canSeeTabs = () => {
		const isManyDaysEvent =
			eventResumeData.value.step1.duration.period ===
			EVENT_PERIOD_IDS.MANY_DAYS;
		return isManyDaysEvent && !isCancelled;
	};
	return (
		<CheckEventExistence
			loadingRequest={loadingRequest}
			defaultPath={ABSOLUTE_PATHS.EVENT_LIST}
		>
			<ContainerForm>
				<HelmetUTP title="Detalle de evento" />
				<ToastMessage
					{...toastMessage}
					toggleHidden={() =>
						setToastMessage({ ...toastMessage, hidden: true })
					}
				/>
				<Preloader
					hidden={isOnlyDayEvent() || eventDateListGroup !== null}
				/>
				<BackToView
					text="Volver a eventos"
					to={ABSOLUTE_PATHS.EVENT_LIST}
				/>
				<ContentForm>
					{eventResumeData.value && (
						<Column marginBottom="10px">
							<HeaderDetail
								title={eventResumeData.value.step1.title}
								speaker={eventResumeData.value.step2.teacher}
							/>
							{canSeeTabs() && (
								<CustomTabs
									viewTabTitles={EVENT_DETAIL_TABS_INFO}
									currentTabIdx={currentTabIdx}
									changeCurrentTabIdx={setCurrentTabIdx}
									tabWidth={200}
								/>
							)}
						</Column>
					)}
					{views[currentTabIdx]}
				</ContentForm>
				{eventResumeData.value && (
					<Footer className={!canUpdate ? "one" : ""}>
						{canUpdate && (
							<CustomButton
								text="Eliminar"
								variant="sixtinary"
								onClick={() => deleteEvent.dialog.set(true)}
							/>
						)}
						<CustomButton
							text="Cerrar"
							onClick={goToEventList}
						/>
					</Footer>
				)}
			</ContainerForm>
			{!isTeacherUser && (
				<>
					<DialogAlertAction
						show={deleteEvent.dialog.value}
						toggleShow={deleteEvent.dialog.toggle}
						variant="secondary"
						title="¿Estás seguro de eliminar este evento completo?"
						contentComponent={getRenderContentToDeleteEvent()}
					>
						<CustomButton
							variant="quintinary"
							text="Sí, eliminar"
							onClick={deleteEvent.action}
						/>
						<CustomButton
							variant="quaternary"
							text="No, cancelar"
							onClick={() => deleteEvent.dialog.set(false)}
						/>
					</DialogAlertAction>
				</>
			)}
			<Preloader {...loadingRequest.value} />
		</CheckEventExistence>
	);
};

export default EventDetailView;
